import React, { useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';

import {
    Modal,
    Form,
    Input,
    TextArea,
    Button
} from '@gpstrackit/gtc-react-controls';

import { Alert } from '@mui/material';

import { NotificationManager } from 'Components/Notifications';

//actions
import {
    reset,
    closeRenameModal,
    renameForm
} from './redux/slice';

import './styles.scss';

const RenameForm = (props) => {
    const { messages } = useIntl();
    const dispatch = useDispatch();

    const { refresh } = props;

    const updateFormRef = Form.useForm();

    const open = useSelector(state => state.dynamicFormsRenameRedux.open);
    const response = useSelector(state => state.dynamicFormsRenameRedux.response);
    const loading = useSelector(state => state.dynamicFormsRenameRedux.loading);
    const dynamicForm = useSelector(state => state.dynamicFormsRenameRedux.dynamicForm);
    const error = useSelector(state => state.dynamicFormsRenameRedux.error);

    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        if (open && updateFormRef?.ref && dynamicForm) {
            let timer = setTimeout(() => {
                updateFormRef.setValues({ name: dynamicForm?.name, description: dynamicForm?.description });
                timer = null;
            }, 100);
        }
    }, [updateFormRef?.ref, open, dynamicForm]);

    useEffect(() => {
        if (open && response && !response?.error) {
            NotificationManager.success(
                messages['dynamicFormsRename_successMessage'],
                messages['dynamicFormsRename_success'],
                3000,
                null,
                null,
                'success',
                null
            );

            if (refresh) refresh();
            handleClose();
        }
    }, [open, response]);

    useEffect(() => {
        if (open && error) {
            setErrorMessage(response?.error || messages['errorMessage']);
            dispatch(reset({ error: false, response: null }));
        }
    }, [error, open, response]);

    const handleClose = useCallback(() => {
        updateFormRef?.resetValues();
        setErrorMessage("");
        dispatch(closeRenameModal());
        dispatch(reset());
    });

    return (
        <Modal
            title={`${messages['dynamicFormsRename_title']}: "${dynamicForm?.name}"`}
            open={open}
            loading={loading}
            position="right"
            size="medium"
            handleClose={handleClose}
            footer={(
                <div style={{ display: 'flex', alignItems: "center", justifyContent: 'end', width: '100%' }}>
                    <Button
                        disabled={loading}
                        style={{ marginRight: 8 }}
                        onClick={handleClose}
                        variant='secondary'
                    >
                        {messages['cancel']}
                    </Button>

                    <Button
                        disabled={loading || !dynamicForm}
                        onClick={(e) => {
                            if (e) e.preventDefault();
                            updateFormRef?.submit();
                        }}
                        variant='primary'
                    >
                        {messages['save']}
                    </Button>
                </div>
            )}
        >
            <div className='rename-form-container'>
                <Form
                    ref={updateFormRef.ref}
                    loading={loading}
                    onValidSubmit={(values) => {
                        setErrorMessage("");
                        dispatch(renameForm({ ...values, id: dynamicForm?.id }));
                    }}
                    onChangeValues={() => setErrorMessage("")}
                >
                    <div>
                        <Form.Item
                            name="name"
                            label={messages['dynamicFormsDesign_name']}
                            rules={[{ required: true, message: 'required_field' }]}
                        >
                            <Input
                                id="name"
                                type="text"
                                placeholder={messages['dynamicFormsDesign_name']}
                                maxLength={300}
                            />
                        </Form.Item>

                        <Form.Item
                            name="description"
                            label={messages['dynamicFormsDesign_description']}
                        >
                            <TextArea
                                id="description"
                                placeholder={messages['dynamicFormsDesign_description']}
                                maxLength={500}
                            />
                        </Form.Item>

                        {errorMessage &&
                            <Alert severity="error" onClose={() => setErrorMessage("")}>{errorMessage}</Alert>
                        }
                    </div>
                </Form>
            </div>
        </Modal>
    );
}

export default RenameForm;